import { render } from "./check.vue?vue&type=template&id=d75530bc&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"

import "./check.vue?vue&type=style&index=0&id=d75530bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d75530bc"

export default script